import React from 'react';
import { observer } from 'mobx-react';
import memberStore from '../../stores/member.store';
import PrefMenu from '../pref_menu.component';

const itemsOrig: {name: string; url: string; isNew?: boolean}[] = [
  {name: 'General', url: 'general'},
  {name: 'Apps', url: 'apps'},
  {name: 'Plan & Usage', url: 'plan'},
  {name: 'Billing', url: 'billing'},
  {name: 'Members', url: 'members'},
  {name: 'Authentication Keys', url: 'authkeys'},
  {name: 'Code Repositories', url: 'code-repositories', isNew: true},
  {name: 'Slack Integration', url: 'integrations'},
  {name: 'Webhooks', url: 'webhooks'},
  {name: 'MCP Integration', url: 'mcp-integration'},
  {name: 'OAuth Connections', url: 'oauth-connections'},
];

const PrefAccountMenu = observer(() => {
  const account = memberStore.account!;
  const {appId} = memberStore;
  const prefUrl = '/' + account._id  + '/preferences' ;
  const items = itemsOrig.map((item) => {
    return {name: item.name, url: prefUrl + '/' + item.url, isNew: item.isNew};
  });

  const menuLink = {
    name: 'App Preferences',
    url: `/${account._id}/${appId}/preferences/general`,
  }

  return (
    <PrefMenu title="Account Preferences" subTitle={account.name} items={items} menuLink={menuLink}  referAndEarn={true}/>
  );
}); 

export default PrefAccountMenu;

